import React, { useState, useRef } from "react";
import { NodeViewWrapper } from "@tiptap/react";

export const ImageView = ({ node, updateAttributes, selected }) => {
  const [isResizing, setIsResizing] = useState(false);
  const [startX, setStartX] = useState(0);
  const [startWidth, setStartWidth] = useState(0);
  const imgRef = useRef(null);

  const startResize = (e) => {
    e.preventDefault();
    setIsResizing(true);
    setStartX(e.clientX);
    setStartWidth(imgRef.current.offsetWidth);
  };

  const handleMouseMove = (e) => {
    if (!isResizing) return;
    const diff = e.clientX - startX;
    const newWidth = Math.max(50, startWidth + diff);
    updateAttributes({ width: newWidth });
  };

  const stopResize = () => {
    setIsResizing(false);
  };

  React.useEffect(() => {
    if (isResizing) {
      document.addEventListener("mousemove", handleMouseMove);
      document.addEventListener("mouseup", stopResize);
    } else {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", stopResize);
    }
    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", stopResize);
    };
  }, [isResizing]);

  return (
    <NodeViewWrapper
      as="span"
      style={{
        display: "inline-block",
        position: "relative",
        verticalAlign: "middle",
      }}
    >
      <img
        ref={imgRef}
        src={node.attrs.src}
        alt={node.attrs.alt || ""}
        width={node.attrs.width || "auto"}
        height={node.attrs.height || "auto"}
        style={{
          display: "inline-block",
          maxWidth: "100%",
          border: selected ? "2px solid #2684ff" : "none",
          borderRadius: "4px",
        }}
      />
      {selected && (
        <span
          onMouseDown={startResize}
          style={{
            position: "absolute",
            right: 0,
            bottom: 0,
            width: "10px",
            height: "10px",
            background: "#2684ff",
            cursor: "nwse-resize",
            borderRadius: "2px",
          }}
        />
      )}
    </NodeViewWrapper>
  );
};
